import { heatRank } from '@/mocks/homeContent';

export default function HeatRank() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-[1240px] px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary-100 text-secondary-900">
              <i className="ri-fire-line flex h-5 w-5 items-center justify-center" />
            </span>
            <div>
              <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">全网热议热榜</h2>
              <p className="mt-1 text-xs text-foreground-500">按实时讨论热度滚动更新，点击可进对应专题话题</p>
            </div>
          </div>
          <a href="#专题话题" className="flex items-center gap-1 whitespace-nowrap text-sm font-bold text-primary-600 transition hover:text-primary-700">
            去专题话题看看 <i className="ri-arrow-right-line flex h-4 w-4 items-center justify-center" />
          </a>
        </div>

        <div className="grid gap-3 md:grid-cols-2 md:gap-4">
          {heatRank.map((it) => (
            <a
              key={it.rank}
              href="#专题话题"
              className="group flex items-center gap-3 rounded-xl bg-background-100 p-3 ring-1 ring-background-200 transition hover:ring-accent-300 md:p-4"
            >
              <span
                className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-label text-xl ${
                  it.rank <= 3 ? 'bg-primary-500 text-background-50' : 'bg-secondary-200 text-secondary-900'
                }`}
              >
                {String(it.rank).padStart(2, '0')}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-start justify-between gap-2">
                  <h3 className="line-clamp-1 flex-1 text-sm font-bold text-foreground-900 transition group-hover:text-primary-700 md:text-base">
                    {it.title}
                  </h3>
                  <span className="shrink-0 whitespace-nowrap text-xs font-bold text-primary-600">↑{it.up}</span>
                </div>
                <div className="mt-2 flex items-center gap-2">
                  <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
                    <div className="h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500" style={{ width: `${it.heat}%` }} />
                  </div>
                  <span className="whitespace-nowrap rounded-sm bg-secondary-100 px-1.5 py-0.5 text-[10px] font-bold text-secondary-900">{it.tag}</span>
                  <span className="w-7 shrink-0 whitespace-nowrap text-right font-label text-xs text-accent-700">{it.delta}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}